import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { User } from '../models/user';

const TOKEN_KEY = 'rx_token';
const USER_KEY = 'rx_user';

@Injectable({ providedIn: 'root' })
export class StorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  setToken(token: string): void {
    if (!this.isBrowser) return;
    sessionStorage.setItem(TOKEN_KEY, token);
  }

  getToken(): string | null {
    if (!this.isBrowser) return null;
    return sessionStorage.getItem(TOKEN_KEY);
  }

  setUser(user: User): void {
    if (!this.isBrowser) return;
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  getUser(): User | null {
    if (!this.isBrowser) return null;

    const raw = sessionStorage.getItem(USER_KEY);
    if (!raw) return null;

    try {
      return JSON.parse(raw) as User;
    } catch (e) {
      console.error('Failed to parse stored user', e);
      this.removeUser();
      return null;
    }
  }

  removeUser(): void {
    if (!this.isBrowser) return;
    sessionStorage.removeItem(USER_KEY);
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  clear(): void {
    if (!this.isBrowser) return;
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  }
}
